module.exports = __webpack_public_path__ + "static/SöhneBreit-Dreiviertelfett-4bef0cfaa7947b97b1040478c3d49289.otf";